// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"AssetLogoContainer-module__wrapper--rC6YW","shouldUseBorderOnFallback":"AssetLogoContainer-module__shouldUseBorderOnFallback--vFDSf"};